import VideoCaptureModal from '@components/VideoCaptureModal';
import { uploadThumb } from '@modules/alioss';
import { $sceneMapApi } from '@stores/dataStores';
import { $member } from '@stores/memberStores';
import { type GeneralID, ImageType, type SceneData, SceneType } from '@types';
import addComponent from '@utils/addComponent';
import getPanoViewTrackList from '@utils/getPanoViewTrackList';
import { thumbPrefix } from '@utils/prefixMaker';
import ThumbReplaceModal from '../ThumbReplaceModal';

const upload = async (id: GeneralID, file: File) => {
  const memberData = $member.getState();
  const prefix = thumbPrefix({ memberData, sceneId: id });
  const url = await uploadThumb({ file, prefix });
  $sceneMapApi.update((draft) => {
    draft.get(id)!.thumbUrl = url;
  });
};

export function changeThumb(data: SceneData) {
  const { id, thumbUrl, type, transcodeTrack, cdnDomain, originTrack } = data;
  if (type === SceneType.pano || type === SceneType.matrix) {
    addComponent((remove) => (
      <ThumbReplaceModal
        sceneData={data}
        thumbSrc={thumbUrl}
        onRequestClose={remove}
        onConfirm={async (file) => {
          await upload(id, file);
        }}
      />
    ));
  } else if (type === SceneType.panoVideo) {
    const videoUrl = (() => {
      const tracks = getPanoViewTrackList({
        transcodeTrack,
        cdnDomain,
        originTrack,
      });
      return tracks[0].url;
    })();
    addComponent((remove) => (
      <VideoCaptureModal
        coverSrc={thumbUrl}
        coverType={ImageType.thumb}
        videoUrl={videoUrl}
        title="场景封面设置"
        onRequestClose={remove}
        onConfirm={async (file) => {
          await upload(id, file);
        }}
      />
    ));
  }
}
